import { MAX_CHARS_IN_ABOUT_MOBILE } from '@utils/constants';
import { PublicCertification } from '@wix/ambassador-academy-certifications-v1-account-certification/build/cjs/types.impl';
import { Platforms } from '@wix/ambassador-partner-profiles/types';
import { Box } from '@wix/design-system';
import { FC } from 'react';
import ShowMoreText from '../../ShowMoreText';
import Certifications from '../Certifications';
import { shouldRenderCertifications } from '../Certifications/CertificationsUtils';
import Services from '../Services';
import { useHasServices } from '../Services/useHasServices';
import s from './About.module.scss';
import ContactDetails from './ContactDetails';

type Props = {
  about?: string;
  platforms?: Platforms;
  certifications: PublicCertification[];
};

const AboutMobile: FC<Props> = ({ about, platforms, certifications }) => {
  const hasServices = useHasServices();
  const hasCertifications = shouldRenderCertifications(certifications);
  return (
    <Box direction="vertical" className={s.aboutMobile} width="100%" gap="18px">
      <Box
        dataHook="about-container"
        className={`${s.aboutContainer} ${s.mobile}`}
        direction="vertical"
      >
        <ShowMoreText
          originalText={about}
          maxChars={MAX_CHARS_IN_ABOUT_MOBILE}
          textSize="medium"
        />
      </Box>

      {hasCertifications && (
        <Box direction="vertical" className={s.certificationsMobileContainer}>
          <Certifications
            isMobileView={true}
            variant="detailed"
            data={certifications}
          />
        </Box>
      )}

      {hasServices && (
        <Box direction="vertical" className={s.servicesMobileContainer}>
          <Services isMobileView={true} />
        </Box>
      )}

      <ContactDetails
        platforms={platforms}
        isMobileView={true}
        className={s.contactMobileContainer}
      />
    </Box>
  );
};

export default AboutMobile;
